import React, {Component} from 'react';
import {withRouter} from 'react-router-dom'
import {API_ROOT, DOMAIN} from "../api-config";
import ReactPlaceholder from "react-placeholder";
import {RectShape} from "react-placeholder/lib/placeholders";
import Modal from "react-responsive-modal";
import Steps from './steps';
import SubSteps from './substeps';
import Swal from "sweetalert2";

class ticketcount extends Component {

    constructor(props, context) {
        super(props, context);
        console.log(DOMAIN);

        this.state = {
            ready: true,
            open: false,
            guestCount: 1,
            swalButton: "",
        };

    };

    componentWillMount() {
        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'btn-green',
                    cancelButton: 'btn-green'
                },
                buttonsStyling: false,
            })
        });
        sessionStorage.setItem("currentComponent", 0);
    }


    componentDidMount() {


        if (sessionStorage.getItem("userGuestCount")) {

            this.setState({guestCount: parseInt(sessionStorage.getItem("userGuestCount"))})
        } else {
            this.setState({guestCount: 1});
        }
        console.log("GUEST COUNT");
    }

    verifyTickets = () => {

        var eventID = sessionStorage.getItem("eventID");
        var merchantID = localStorage.getItem("merchant_id");
        var eventDate = sessionStorage.getItem("userEventDate");
        var eventTime = sessionStorage.getItem("userEventTime");
        var url = API_ROOT + '/verifytickets?event_id=' + eventID + "&event_time=" + eventTime + "&event_date=" + eventDate + "&merchant_id=" + merchantID + "&totalTickets=" + this.state.guestCount;


        this.onOpenModal();
        fetch(url)
            .then(response => {
                return response.json();
            })
            .then(events => {
                this.onCloseModal();

                if (events.status == 1) {




                    sessionStorage.setItem("userGuestCount", this.state.guestCount);

                    this.props.onComponentUp(2);



                } else {

                    this.state.swalButton.fire({
                        title: events.message,
                        allowOutsideClick: false
                    });
                }

            });

    };
    moveForward = () => {

        this.verifyTickets();
    }
    goBack = () => {
        this.props.onComponentDown(2);
    }
    plusQty = e => {


        var qty = this.state.guestCount;
        if (sessionStorage.getItem("guestMax") === "null") {

            qty = qty + 1;
            console.log("PLUS" + qty);
            this.setState({guestCount: qty});

        } else if (qty < parseInt(sessionStorage.getItem("guestMax"))) {


            qty = qty + 1;
            console.log("PLUS" + qty);
            this.setState({guestCount: qty});
        }


    }
    minusQty = e => {

        var qty = this.state.guestCount;
        if (qty > 1) {
            qty = qty - 1;
            console.log("PLUS" + qty);
            this.setState({guestCount: qty});
        }
    }

    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    render() {

        const {open} = this.state;
        const rightPlaceholder = (
            <div className='my-awesome-placeholder'>
                <RectShape color='whitesmoke' className="img-fluid" style={{width: "100%", height: "642px"}}/>

            </div>
        );

        return (<ReactPlaceholder ready={this.state.ready}
                                  customPlaceholder={rightPlaceholder}>
            <Steps componentChange={this.props.onComponentChange}/>
            <SubSteps/>
            <div className="title_div mb-30">
                <h1>How Many Tickets<br/>
                    Would you Like to Purchase ?</h1>
            </div>
            <div className="guest_block clearfix">
                <form>
                    <div className="input-group">
                        <input type="button" value="" className="button-minus" data-field="quantity"
                               onClick={this.minusQty}/>
                        <input type="number" step="1" min="1" max={sessionStorage.getItem("guestMax")}
                               value={this.state.guestCount} name="quantity" className="quantity-field"/>
                        <input type="button" value="" className="button-plus" data-field="quantity"
                               onClick={this.plusQty}/>
                    </div>
                </form>
            </div>
            <p className="text-center guest_p">${sessionStorage.getItem("eventBasePrice")} per ticket</p>
            <div className="btn-green-block clearfix">

                <button onClick={this.moveForward} className="btn-green font-nunito-semibold float-right">Continue
                </button>
            </div>
            <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                   onClose={this.onCloseModal} center>
                <h2>&nbsp;&nbsp;&nbsp;&nbsp;Loading...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                <p style={{textAlign: 'center'}}>
                    <img width={'40'} height={'40'} alt="Loading..." src={'/img/loading1.gif'}/>
                </p>
            </Modal>
        </ReactPlaceholder>)

    }
}

export default withRouter(ticketcount);